import React from 'react'
import { Col, Form } from 'react-bootstrap'

const DynamicSelect = (props) => {
   const {
      form,
      formState,
      setFormState,
      name,
      options,
      isRequired,
      title
   } = props

   const animationEndHandler = () => {
      form.current.classList.remove('shake1')
   }

   const onChangeHandler = (evt) => {
      formState[name] = evt.target.value
      setFormState(formState)
   }

   const renderError = () => {
      if (isRequired) {
         return (
            <Form.Control.Feedback type="invalid">
               {isRequired.errorMessage}
            </Form.Control.Feedback>
         )
      }
      return null
   }

   return (
      <Form.Group as={Col} xs={12} className='mb-3'>
         <Form.Label htmlFor={name}>
            {title}
         </Form.Label>
         <Form.Select id={name} required={isRequired} size='sm' onAnimationEnd={animationEndHandler} onChange={onChangeHandler}>
            {options.map(({ value, name }) => <option key={`${name}-${value}`} value={value}  > {name}</option>)}
         </Form.Select>
         {renderError()}
      </Form.Group>
   )
}
export default DynamicSelect